// extracted by mini-css-extract-plugin
export default {"homeContainer":"Home_homeContainer__GxC9g","logoContainer":"Home_logoContainer__-IDzw","header":"Home_header__jgN9+"};